//
// Fork
// https://github.com/dcousens/ordinal.js
//

function indicator(value) {
  const absValue = Math.abs(value);
  const cent = absValue % 100;
  if (cent >= 10 && cent <= 20) {
    return 'th';
  }

  const dec = absValue % 10;
  switch (dec) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}

function ordinal(value) {
  if (typeof value !== 'number') {
    throw new TypeError(`Expected Number, got ${typeof value}  ${value}`);
  }
  if (!Number.isFinite(value)) {
    return value;
  }
  return `${value}${indicator(value)}`;
}

export default ordinal;
